<template>
    <div class="aba-campanha select-modal" style="heigth: 100%">
        <div class="vertical-flow">
            <div class="columns">
                <div
                    class="column"
                    :class="[
                        permissaoTelaAssCampanha.create &&
                        !permissaoIntegracaoAssCampanha &&
                        permissaoTelaCampanha.create &&
                        !permissaoIntegracaoCampanha
                            ? 'is-4'
                            : permissaoTelaAssCampanha.create &&
                              !permissaoIntegracaoAssCampanha &&
                              (!permissaoTelaCampanha.create || permissaoIntegracaoCampanha)
                            ? 'is-7'
                            : permissaoTelaCampanha.create &&
                              !permissaoIntegracaoCampanha &&
                              (!permissaoTelaAssCampanha.create || permissaoIntegracaoAssCampanha)
                            ? 'is-10'
                            : 'is-4',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-usuario-campanha"
                    />
                </div>
                <div class="column is-2">
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>
                <div
                    class="column is-3"
                    v-if="permissaoTelaAssCampanha.create && !permissaoIntegracaoAssCampanha"
                >
                    <button class="save-btn botao-acao" type="button" @click="showModalLote">
                        {{ $t('vincular-campanha') }}
                    </button>
                </div>
                <div
                    class="column is-3"
                    v-if="!permissaoIntegracaoCampanha && permissaoTelaCampanha.create"
                >
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="
                            $router.push({
                                name: 'ven-campanha-new',
                                query: {
                                    tela: 'usuario-campanha',
                                    id: $route.params.id,
                                    name: $route.params.name,
                                },
                            })
                        "
                    >
                        {{ $t('adicionar-campanha') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assLotes"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.label) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'descricaolote'">
                            <a
                                @click="selectedLoteEdit(props.row)"
                                v-if="
                                    permissaoTelaAssCampanha.update &&
                                    !permissaoIntegracaoAssCampanha
                                "
                            >
                                {{ props.row[f.key] }}
                            </a>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <b-button
                                v-if="
                                    permissaoTelaAssCampanha.update &&
                                    !permissaoIntegracaoAssCampanha
                                "
                                class="action-button"
                                :type="props.row['situacao'] == 1 ? 'is-danger' : 'is-success'"
                                :icon-right="props.row['situacao'] == 1 ? 'delete' : 'check'"
                                @click="promptChangeSituacao(props.row)"
                                v-tippy
                                :title="$t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['situacao'] == 1 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['situacao'] == 1 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao" @close="fecharModal">
                <div class="bg">
                    <CampanhaModal
                        :idUsuario="$route.params.id"
                        :selected="assLoteSelected"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import AssUsuarioCampanhaService from '@/services/colaborador/AssUsuarioCampanhaService';
import Message from '@/models/Message';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import CampanhaModal from '@/components/colaborador/gerenciar-usuario/modal/CampanhaModal';

export default {
    components: {
        CampanhaModal,
        ContainerLoader,
    },
    data() {
        return {
            service: null,
            produtoService: null,
            validation: null,
            idpedido: 0,
            campanha: {},
            fields: [
                { key: 'idassusuariocampanha', width: null, label: 'codigo', sortable: true },
                { key: 'descricaocampanha', width: null, label: 'campanha', sortable: true },
                {
                    key: 'datavalidadeformatada',
                    width: null,
                    label: 'data-validade',
                    sortable: true,
                },
                { key: 'situacao', width: null, label: 'situacao', sortable: true, sortFn: null },
                { key: 'excluir', width: null, label: 'excluir', sortable: false },
            ],
            permissaoIntegracaoAssCampanha: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSCAMPANHAUSUARIO'
            ),
            permissaoIntegracaoCampanha: this.$store.state.user.tabelasERPWebServer.includes(
                'CAMPANHA'
            ),
            permissaoTelaAssCampanha: null,
            permissaoTelaCampanha: null,
            assLotes: [],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            assLoteSelected: null,
            debouncedOnSearch: null,
            queryFilter: '.*',
            column: 'descricao',
            order: 'desc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            isUpdate: false,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissaoTelaAssCampanha = this.hasPermissionAccess(
            'admin',
            'colaborador',
            'usuario-usuario-campanha'
        );

        this.permissaoTelaCampanha = this.hasPermissionAccess('vendas', 'vendas', 'ven-campanha');

        this.service = new AssUsuarioCampanhaService(this.$http, this.$router);
        this.idusuario = this.$route.params.id;
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },

    methods: {
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.findByIdUsuario();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1){
                this.pagination.resetPagination = true;
            }
            this.isLoading = true;

            this.service
                .findByIdUsuario(
                    this.idusuario,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.order,
                    this.column,
                    this.situacaoSelected.id,
                    this.queryFilter
                )
                .then(this.mapAssProdutoLote)
                .then((value) => {
                    this.assLotes = value;
                    this.isEmpty = this.assLotes.length <= 0;
                })
                .catch((e) => {
                    console.error('Erro ao carregar campanha.', e);
                    this.msgs.push(new Message('error', 'msg-erro-un-medida', true));
                })
                .finally(() => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        mapAssProdutoLote(item) {
            this.pagination.totalRows = item.totalElements;

            return item.content.map((r) => {
                return {
                    idassusuariocampanha: r.idassusuariocampanha,
                    idcampanha: r.campanha ? r.campanha.idcampanha : null,
                    idusuario: r.usuario ? r.usuario.idusuario : null,
                    descricaocampanha: r.campanha ? r.campanha.descricao : null,
                    datavalidadeformatada: r.campanha ? r.campanha.datavalidadeformatada : null,
                    nomeusuario: r.usuario ? r.usuario.nome : null,
                    situacao: r.situacao,
                };
            });
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['descricaocampanha'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure = this.$t(
                    this.delete.situacao == 0 
                        ? 'msg-erro-ao-reativar-n' 
                        : 'msg-erro-ao-desativar-n', 
                    { n: this.$t('campanha') }
                );
            let tempAssUsuarioCampanha = {
                idassusuariocampanha: this.delete.idassusuariocampanha,
                situacao: this.delete.situacao == 0 ? 1 : 0,
            };

            this.isLoading = true;
            this.service
                .updateSituacao(tempAssUsuarioCampanha)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess = this.$t(
                                r.content.situacao == 1
                                    ? 'msg-sucesso-ao-reativar-n'
                                    : 'msg-sucesso-ao-desativar-n', 
                                { n: this.$t('campanha') }
                            );
                        this.$root.showMessage('success', tempSuccess, true, false);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        selectedLoteEdit(selected) {
            this.isUpdate = true;
            this.assLoteSelected = selected;
            this.showModalAssociacao = true;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.isUpdate = false;
            this.showModalCadastroLote = false;
            this.carregarDados();
        },
        showModalLote() {
            this.showModalAssociacao = !this.showModalAssociacao;
            this.assLoteSelected = null;
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-campanha {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
